document.addEventListener('turbolinks:load', () => {
  if (!document.querySelector('.areas-map')) { return; }
  import('src/areas_map'); // eslint-disable-line
});
